'use strict';

const React = require('react');

const PropTypes = require('prop-types');

function CollectionsItem(props) {
    const {title, url, image} = props.item;
    const {index} = props;

    return (
        <a className="collections-carousel-item-link" href={url} data-index={index} onClick={() => props.onClick(props.item, index)}>
            <div className="collections-carousel-item-image-wrapper">
                <img className="collections-carousel-item-image is-centered" src={image} alt={title} />
            </div>
            <span className="collections-carousel-item-title">{title}</span>
        </a>
    );
}

CollectionsItem.propTypes = {
    index: PropTypes.number,
    item: PropTypes.object,
    item: PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.string
    }),
    onClick: PropTypes.func
};

module.exports = CollectionsItem;



// WEBPACK FOOTER //
// ./assets/js/home/components/CollectionsItem.jsx